import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MassiveModule } from './components/massive/massive.module';
import { LayoutModule } from './components/layout/layout.module';

// components prime

import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SelectButtonModule } from 'primeng/selectbutton';

import { CookieService } from 'ngx-cookie-service';
import { CediStoreModule } from './components/cedi-store/cedi-store.module';
import { AddressCardComponent } from './components/shared/sharedComponents/address-card/address-card.component';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormControlValidatorService } from './components/shared/sharedServices/form-control-validator.service';
import { MuContextSettings } from './components/shared/types/contextSettings.type';
import { DesignSystemModule } from './components/shared/sharedModules/designSystem/design-system.module';
import { MuHttpService } from './components/shared/sharedServices/mu-http.service';
import { UserDataService } from './components/shared/sharedServices/user-data.service';
import { UtilsService } from './components/shared/sharedServices/utils.service';
import { SharedAuthModule } from './components/shared/sharedModules/auth/shared-auth.module';
import { PixelModule } from 'ngx-pixels';
import { environment } from 'src/environments/environment.prod';
import { NgxIndexedDBModule, NgxIndexedDBService } from 'ngx-indexed-db';
import { indexDbConfig } from 'src/environments/constants';
import { PointsUserService } from './components/shared/sharedServices/points-user.service';
import { IndexedDbService } from './components/shared/sharedServices/indexed-db.service';
import { PermissionService } from './components/shared/sharedModules/permission/permission.service';

@NgModule({
  declarations: [AppComponent, AddressCardComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    LayoutModule,
    MassiveModule,
    CediStoreModule,
    ScrollPanelModule,
    NgxIndexedDBModule.forRoot(indexDbConfig),
    SelectButtonModule,
    DesignSystemModule,
    HttpClientModule,
    SharedAuthModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: MuContextSettings.language(null),
        deps: [HttpClient],
      },
    }),
    PixelModule.forRoot({
      enabled: true,
      fbPixelId: environment.FacebookPixelId,
    }),
  ],
  providers: [
    CookieService,
    FormControlValidatorService,
    TranslateService,
    UserDataService,
    PointsUserService,
    PermissionService,
    NgxIndexedDBService,
    IndexedDbService,
    UtilsService,
    MuHttpService,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModule {}
